export const isProd = window.location.host === "www.digipost.no";
export const isDifitest = window.location.host === "www.difitest.digipost.no";

export const isLocalEnvironment = import.meta.env.MODE !== "production";

export const applications = {
  ADMIN: "/admin/",
  PRIVAT: "/postkasse/",
  VIRKSOMHET: "/virksomhetsadmin/",
  REGISTRERING: "/registrering/",
};
